/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * UIBFS Membership Service API
 * Membership programmes, applications, and category management endpoints.
 * OpenAPI spec version: 1.0.0
 */

/**
 * Gender
 */
export type ApplicationUpdateDTOGender =
  (typeof ApplicationUpdateDTOGender)[keyof typeof ApplicationUpdateDTOGender];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApplicationUpdateDTOGender = {
  FEMALE: "FEMALE",
  MALE: "MALE",
} as const;
